"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _downshift = _interopRequireDefault(require("downshift"));

var _FormGroup = _interopRequireDefault(require("./FormGroup"));

var _getOptionProperties = require("./getOptionProperties");

var _createFilter = _interopRequireDefault(require("./createFilter"));

var _excluded = ["element", "onSelect", "defaultSelectedOption", "getOptionLabel", "value", "spellcheck", "disabled", "filter"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var AutocompleteField = function AutocompleteField(_ref) {
  var Element = _ref.element,
      onSelect = _ref.onSelect,
      defaultSelectedOption = _ref.defaultSelectedOption,
      getOptionLabel = _ref.getOptionLabel,
      value = _ref.value,
      spellcheck = _ref.spellcheck,
      disabled = _ref.disabled,
      filter = _ref.filter,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_downshift.default, {
    itemToString: getOptionLabel,
    onChange: onSelect,
    inputValue: value,
    defaultSelectedItem: defaultSelectedOption
  }, function (_ref2) {
    var getInputProps = _ref2.getInputProps,
        getItemProps = _ref2.getItemProps,
        getMenuProps = _ref2.getMenuProps,
        isOpen = _ref2.isOpen,
        inputValue = _ref2.inputValue,
        highlightedIndex = _ref2.highlightedIndex,
        selectedItem = _ref2.selectedItem,
        getToggleButtonProps = _ref2.getToggleButtonProps,
        clearSelection = _ref2.clearSelection;
    return /*#__PURE__*/_react.default.createElement(Element, null, /*#__PURE__*/_react.default.createElement(_FormGroup.default, _extends({
      getInputProps: getInputProps,
      getItemProps: getItemProps,
      getMenuProps: getMenuProps,
      isOpen: isOpen,
      inputValue: inputValue,
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem,
      getToggleButtonProps: getToggleButtonProps,
      clearSelection: clearSelection,
      getOptionLabel: getOptionLabel,
      value: value,
      disabled: disabled,
      filter: filter,
      spellcheck: spellcheck
    }, props)));
  });
};

AutocompleteField.propTypes = {
  element: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  defaultSelectedOption: _propTypes.default.shape({}),
  disabled: _propTypes.default.bool,
  filter: _propTypes.default.func,
  getOptionLabel: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  spellcheck: _propTypes.default.bool,
  value: _propTypes.default.string
};
AutocompleteField.defaultProps = {
  element: 'div',
  defaultSelectedOption: undefined,
  disabled: false,
  filter: _createFilter.default,
  getOptionLabel: _getOptionProperties.getOptionLabel,
  onSelect: undefined,
  spellcheck: true,
  value: undefined
};
AutocompleteField.displayName = 'AutocompleteField';
var _default = AutocompleteField;
exports.default = _default;